import { USER_ITEM_SUPPORT } from '../../../constants/user'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_INITIAL_VALUES,
  toEmailRecipientSelectItem,
} from '../../Email'

export const EPOST_CONTACT_SUPPORT_EMAIL_MODAL_INITIAL_VALUES = {
  ...EMAIL_CREATION_FORM_INITIAL_VALUES,
  [EMAIL_CREATION_FORM_FIELD_NAME_TO]: [
    toEmailRecipientSelectItem(USER_ITEM_SUPPORT),
  ],
}

export const EPOST_SUPPORT_MODAL_SOURCE_ID = 'epost-support'
